import {Header} from "./Components/Sections/Header";
import {Form} from "./Classes/Form";
import {BrandsOverview} from "./Components/Sections/BrandsOverview";
import {WorkSlider} from "./Components/Sections/WorkSlider";
import {TextGridBlocks} from "./Components/Sections/TextGridBlocks";
import {HoverBlock} from "./Components/Blocks/HoverBlock";
import {Services} from "./Components/Sections/Services";
import {AutomatisationSavingsTool} from "./Components/Blocks/AutomatisationSavingsTool";


class Base
{
  constructor()
  {
      this.initSectionComponents();
      this.initTools();
  }

  initTools()
  {
      Array.from(document.querySelectorAll('[data-tool="automatisation-savings"]')).forEach((tool) => {
          new AutomatisationSavingsTool(tool);
      });
  }

  initSectionComponents()
  {
      new Header();

      Array.from(document.querySelectorAll('[data-node="default-form"]')).forEach((form) => {
          new Form(form, form.parentNode.querySelector('.form-overlay'))
      });

      Array.from(document.querySelectorAll('.brands-overview')).forEach((brandsOverview) => {
          new BrandsOverview(brandsOverview);
      })

      Array.from(document.querySelectorAll('[data-node="work-slider"]')).forEach((workSlider) => {
          new WorkSlider(workSlider);
      })

      Array.from(document.querySelectorAll('[data-node="services"]')).forEach((services) => {
          new Services(services);
      })

      Array.from(document.querySelectorAll('.text-grid-blocks')).forEach((textGrid) => {
          new TextGridBlocks(textGrid);
      })

      Array.from(document.querySelectorAll('.cases-cards .hover-block ')).forEach((block) => {
         new HoverBlock(block);
      });

  }
}

new Base();
